import BgImage from '../../assets/faq/faq-bg.png'
import { Box, Typography, } from '@mui/material'
import SMFAQ from '../../containers/FAQ'
import { useTranslation } from 'react-i18next'

export const FAQScreen: React.FC = () => {

    const { t } = useTranslation()

    // ======================= VIEWS
    return (
        <>
          <Box sx={{ position: 'relative', 
                objectFit: 'cover',
                backgroundImage: `url(${BgImage})`,                
                backgroundSize: 'cover',    
                backgroundPosition: 'center',
                width: '100%',
                height: '457px',
          }}>

          <Box sx={{ position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.3)', justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
              <Typography fontSize={50} fontWeight={600} color={'#FBBF23'} textAlign={'center'}>
                  {t('t379')}
              </Typography>

              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignContent: 'center', alignItems: 'center', paddingTop: '16px' }}>
                  <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                    {t('t380')}
                  </Typography>
                  <Box sx={{ width: '1px', height: '20px', backgroundColor: '#FFFFFF', marginLeft: '20px', marginRight: '20px' }}></Box>
                  <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                    {t('t381')}
                  </Typography>
              </Box>
            </Box>
          </Box>
            <SMFAQ />
        </>
    )
}

// ======================= EXPORT
export default FAQScreen
